exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-tree.cap-tree-v2 li .ant-tree-node-content-wrapper:hover{background-color:#faf9f4}\n", ""]);

// exports
